import {
  dimensiondata_1_engedelyes_group_row,
  dimensiondata_2_tetelek_group_dimension_1_2_3_4_column,
  huf_value_2_data,
  megawatt_ora_value_1_data,
  month_row,
  year_row_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const villamosKerSzolgConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/VillamosKerSzolg',
      select: ['date', 'dimension_1', 'dimension_3', 'value_1', 'value_2'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      year_row_expanded,
      month_row,
      ...dimensiondata_1_engedelyes_group_row,
      ...dimensiondata_2_tetelek_group_dimension_1_2_3_4_column,
      megawatt_ora_value_1_data,
      huf_value_2_data,
      order_1,
      order_2
    ],
  },
};
